import { useSelector } from 'react-redux';
import { selectTopCategories } from 'containers/catalogue/catalogue/selectors';
import { useCatalogueContentSlice } from '../../../../hooks';
import { selectFilterModalState, selectSelectedFilterItems } from '../../../../selectors';

export const useHeader = () => {
	const { closeModal, openModal, resetSelectedFilterItems } = useCatalogueContentSlice();

	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const topCategories = useSelector(selectTopCategories);
	const isModalOpen = useSelector(selectFilterModalState);

	return {
		selectedFilterItems,
		topCategories,
		resetSelectedFilterItems,
		isModalOpen,
		closeModal,
		openModal,
	};
};
